import { render, staticRenderFns } from "./bottomInfo.vue?vue&type=template&id=e353d96a&"
import script from "./bottomInfo.vue?vue&type=script&lang=js&"
export * from "./bottomInfo.vue?vue&type=script&lang=js&"
import style0 from "./bottomInfo.vue?vue&type=style&index=0&id=e353d96a&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e353d96a')) {
      api.createRecord('e353d96a', component.options)
    } else {
      api.reload('e353d96a', component.options)
    }
    module.hot.accept("./bottomInfo.vue?vue&type=template&id=e353d96a&", function () {
      api.rerender('e353d96a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/layout/bottomInfo/bottomInfo.vue"
export default component.exports